import { ODataHeader, ODataString, ODataDate, ODataEnum, ODataDecimal, ODataBoolean } from "pbas-vue-components";
import { translate2 } from "../trans2";
import { formatBytes } from "../utils/file"
import { i18n } from '@/plugins/i18n';
import store from '@/store'

const PlanFilesHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => {
        if (!item) {
          return "";
        }
        return translate2(
          item,
          "Name"
        );
      }
    }),
    allowVisibilityChange: true,
    sortable: false,
    visible: true,
    version: 3
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("EffectiveDate"),
  }),
  new ODataHeader({
    title: "headers.pendinghourstasks.created_by",
    type: new ODataString("CreatedBy"),
  }),
  new ODataHeader({
    title: "headers.member_files.created_on",
    type: new ODataDate("Timestamp"),
  }),
  new ODataHeader({
    title: "globals.category",
    type: new ODataEnum("Identity/FileCategory", {
      getString: (item) => {
        return i18n.t("enums." + item.Identity.FileCategory);
      },
      dropdownItems: store.getters['plansMembers/options']?store.getters['plansMembers/options'].Enums.PlanFileCategory:[]
    }),
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataString("Translations[]/FileSegment/FileType", {
      getString: (item) => {
        if (!item || !item.Translations) {
          return "";
        }
        return translate2(
          item,
          "FileSegment"
        ).FileType;
      },
    }),
    sortable: false,
    version: 1
  }),
  new ODataHeader({
    title: "headers.member_files.size",
    type: new ODataDecimal("Translations[]/FileSegment/FileSize", {
      getString: (item) => {
        if (!item || !item.Translations) {
          return "";
        }
        let size = translate2(
          item,
          "FileSegment"
        ).FileSize;
        size = (size/1024).toFixed(2) + " KB"
        return size;
      },
    }),
    sortable: false,
    version: 1
  }),
  new ODataHeader({
    title: "globals.employer",
    type: new ODataString(
      "Identity/Employer/Current/Translations[]/Name",
      {
        getString: (item) => {
          if (
            !item ||
            !item.Employer ||
            !item.Employer.Current ||
            !item.Employer.Name ||
            item.Employer.Name ===
              ""
          )
            return "";
          return translate2(
            item.Identity.Employer.Current,
            "Name"
          );
        },
      }
    ),
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/FileSegment/PhysicalFileId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/FileSegment/FileName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/FileSegment/Timestamp"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false
  }),
  new ODataHeader({
    title:"Employer/Translations[]/LanguageCode",
    type: new ODataString(
      "Identity/Employer/Current/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title:"Store/Translations[]/LanguageCode",
    type: new ODataString(
      "Identity/Store/Current/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title:"Translations[]/LanguageCode",
    type: new ODataString(
      "Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
export default PlanFilesHeaders;
